import React from 'react';
import {
  vertical_line,
  vertical_first_line
} from './BankPerformance.module.css';
import { numberFormat } from '../../../../common/constants/NumberFormat';
import {
  getFiltersInfo,
  setFiltersInfo
} from '../../../../common/utils/FiltersInfo';
import moment from 'moment';
import { navigate } from 'gatsby';
import { getAcl } from '../../../../common/utils/acl-utils';

const isAdmin = () =>
  getAcl()?.acl?.is_rm && getAcl()?.acl?.can_create_in_principle_sanction;

const BankColumnData = (filteredProduct, changeMonth, bank) => {
  const commonHeaderStyle = 'w-full  items-end mx-auto text-center',
    commonStyle = 'w-full mx-auto text-center',
    totalCommonStyle = 'w-full mx-auto text-center font-bold',
    commonparentGruopStyle =
      '  mx-auto text-center  mb-2 text font-khand font-sm text-black-500 font-semibold absolute ',
    commonColStyle =
      ' mt-2 text-black-500 text-sm  font-khand font-normal overflow-auto';

  const commonParentGroupStyle = {
    fontWeight: 500,
    fontSize: '14px',
    bottom: '34px'
  };
  const colStyle = { fontWeight: '500', opacity: '0.8' };

  const HeaderCommonFormat = ({
    majorColName = '',
    colName,
    colNameClass = ''
  }) => (
    <div className={`${commonHeaderStyle} `}>
      <p
        className={`${commonparentGruopStyle} `}
        style={commonParentGroupStyle}
      >
        {majorColName}
      </p>
      <p
        className={`${commonColStyle} ${colNameClass} 
        
        `}
        style={colStyle}
      >
        {colName}
      </p>
    </div>
  );
  const verticalLine = {
    width: '10px !important',
    style: {
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
      width: '12px !important'
    }
  };

  function addToLocalStorage(status, row) {
    let filtersData = getFiltersInfo();
    let newFilterData = {
      ...filtersData,
      rmId: '',
      productId: filteredProduct ? parseInt(filteredProduct) : '',
      status: status,
      backPage: 'bankReport',
      targetMonth: changeMonth || {
        year: parseInt(moment().format('YYYY')),
        month: parseInt(moment().format('MM'))
      },
      bankFilter: bank?.value ? bank : { value: row?.bankId },
      productType: null
    };
    setFiltersInfo(newFilterData);
    navigate(`/app/dashboard`);
  }

  const addOnlyBankToLocalStorage = row => {
    let filtersData = getFiltersInfo();
    let newFilterData = {
      ...(filtersData || {}),
      rmId: '',
      status: '',
      backPage: 'bankReport',
      startDate: '2020-01-01',
      endDate: moment().format('YYYY-MM-DD'),
      bankFilter: bank?.value ? bank : { value: row?.bankId },
      productId: filteredProduct ? parseInt(filteredProduct) : '',
      productType: null,
      targetMonth: ''
    };
    setFiltersInfo(newFilterData);
    navigate(`/app/dashboard`);
  };

  return [
    {
      name: <HeaderCommonFormat colName="Bank Name" />,
      selector: 'bankName',
      sortable: true,
      cell: row => {
        if (row?.isTotal)
          return <div className="w-full font-bold text-base -ml-3">Total</div>;
        return (
          <p
            className={`${commonStyle} cursor-pointer text-blue-900 font-medium`}
            onClick={() => addOnlyBankToLocalStorage(row)}
          >
            {row?.bankName ? row?.bankName : '---'}
          </p>
        );
      },
      minWidth: '100px !important'
    },
    {
      name: '',
      selector: '',
      sortable: false,
      cell: (row, index) => (
        <p
          className={`${index == 0 ? vertical_first_line : vertical_line}`}
        ></p>
      ),
      ...verticalLine
    },
    {
      name: <HeaderCommonFormat colName="Logins" majorColName="Number" />,
      selector: 'numLogins',
      sortable: true,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } ${row?.leadsLoginCount &&
            'cursor-pointer'} text-blue-900 font-medium `}
          onClick={() =>
            row?.leadsLoginCount && addToLocalStorage('Login', row)
          }
        >
          {row?.leadsLoginCount || 0}
        </p>
      ),
      width: '60px !important'
    },
    {
      name: <HeaderCommonFormat colName="Sanc." />,
      selector: 'numSanc',
      sortable: true,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } ${row?.leadsSanctionCount &&
            'cursor-pointer'} text-blue-900 font-medium `}
          onClick={() =>
            row?.leadsSanctionCount && addToLocalStorage('Sanctioned', row)
          }
        >
          {row?.leadsSanctionCount || 0}
        </p>
      ),
      width: '50px !important'
    },
    {
      name: <HeaderCommonFormat colName="Disb." />,
      selector: 'numDis',
      sortable: true,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } ${row?.leadsDisbursedCount &&
            'cursor-pointer'} text-blue-900 font-medium `}
          onClick={() =>
            row?.leadsDisbursedCount && addToLocalStorage('Disbursed', row)
          }
        >
          {row?.leadsDisbursedCount || 0}
        </p>
      ),
      width: '50px !important'
    },
    {
      name: <HeaderCommonFormat colName="Rej." />,
      selector: 'numRej',
      sortable: true,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } ${row?.leadsRejectCount &&
            'cursor-pointer'} text-blue-900 font-medium `}
          onClick={() =>
            row?.leadsRejectCount && addToLocalStorage('Rejected', row)
          }
        >
          {row?.leadsRejectCount || 0}
        </p>
      ),
      width: '50px !important'
    },
    {
      name: '',
      selector: '',
      sortable: false,
      cell: (row, index) => (
        <p
          className={`${index == 0 ? vertical_first_line : vertical_line}`}
        ></p>
      ),
      ...verticalLine
    },
    {
      name: <HeaderCommonFormat colName="Logins" majorColName="Amount" />,
      selector: 'amtLogins',
      sortable: true,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal mx-8 text-right `}
        >
          &#8377;
          <span className="ml-1">
            {numberFormat(row?.leadsLoginLoanAmount) || 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important',
      style: { marginRight: '0px' }
    },
    {
      name: <HeaderCommonFormat colName="Sanc." />,
      selector: 'amtSanc',
      sortable: true,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal text-right `}
        >
          &#8377;
          <span className="ml-1">
            {numberFormat(row?.leadsSanctionLoanAmount) || 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important',
      style: { marginRight: '0px' }
    },
    {
      name: <HeaderCommonFormat colName="Disb" />,
      selector: 'amtDisb',
      sortable: true,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal text-right `}
        >
          &#8377;
          <span className="ml-1">
            {numberFormat(row?.leadsDisbursedLoanAmount) || 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important'
    },
    {
      name: (
        <div className="w-full pr-2">
          <HeaderCommonFormat colName="Rej." />
        </div>
      ),
      selector: 'amtRej',
      sortable: true,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal text-right pr-2`}
        >
          &#8377;
          <span className="ml-1">
            {numberFormat(row?.leadsRejectLoanAmount) || 0}
          </span>
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important'
    },
    {
      name: '',
      selector: '',
      sortable: false,
      cell: (row, index) => (
        <p
          className={`${index == 0 ? vertical_first_line : vertical_line}`}
        ></p>
      ),
      omit: !isAdmin(),
      ...verticalLine
    },
    {
      name: <HeaderCommonFormat colName="GR" />,
      selector: 'gr',
      sortable: true,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal text-right`}
        >
          &#8377;&nbsp;{numberFormat(row?.gr) || 0}
        </p>
      ),
      maxWidth: '300px !important',
      minWidth: '90px !important',
      omit: !isAdmin()
    },
    {
      name: <HeaderCommonFormat colName="Payout" />,
      selector: 'payout',
      sortable: true,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal text-right`}
        >
          {'---'}
        </p>
      ),
      omit: !isAdmin()
    },
    {
      name: (
        <div className="w-full pr-2">
          <HeaderCommonFormat colName="NR" />
        </div>
      ),
      selector: 'nr',
      sortable: true,
      cell: row => (
        <p
          className={`${
            row?.isTotal ? totalCommonStyle : commonStyle
          } break-normal text-right pr-2`}
        >
          {'---'}
        </p>
      ),
      omit: !isAdmin()
    }
  ];
};

export default BankColumnData;
